import { Injectable } from '@angular/core'

import {
  ApiService,
} from '../api/api.service'

@Injectable()
export class PublicLinkService {
  constructor(
    private apiService: ApiService
  ) {}

  exists(uuid) {
    return this.apiService
      .load(`/public_links/${uuid}/exists`, { skipLoader: true })
  }

  load(uuid) {
    return this.apiService
      .load(`/public_links/${uuid}/show_internally`, { skipLoader: true, throwErrors: true })
  }

  update(uuid: string, payload: any): any {
    return this.apiService
      .update(`/public_links/${uuid}`, { payload }, { skipLoader: true })
  }

  create(payload, uuid, redirectUrl) {
    return this.apiService
      .create(`/public_links`, {
        uuid: uuid,
        redirect_url: redirectUrl,
        payload: payload
      })
  }

  uuid() {
    return this.apiService
      .load(`/public_links/uuid`)
  }

  delete(uuid) {
    return this.apiService
      .delete(`/public_links/${uuid}`)
  }
}
